import moment from "moment";
import { createDataPointProcessor } from "../utils/dataPointProcessor";
import { applyLineGraphState } from "../utils/lineGraphState";
import {
  initializeDictionaries,
  initializeEmotionDict,
  initializeActionDictionaries,
} from "../utils/dictionaries";
import { updateEmotions } from "./emotionHandler";
import {
  transform,
  transformActions,
  transformFilteredData,
  transformAllActions,
  transformStudentSupportData,
  computeParticipationPercentChange,
} from "../utils/transformers";
import {
  processAllSchoolsInDistrict,
  processSpecificSchool,
} from "../utils/processSchools";

export function handleSchool(state, school) {
  const { currentDict, compareDict } = initializeDictionaries();
  const { currentActionDict, compareActionDict } =
    initializeActionDictionaries();
  const currentParticipants = new Set();
  const compareParticipants = new Set();
  const emotionDict = initializeEmotionDict();
  let impactfulActions = { action: {}, emotion: {} };
  let newState = {};
  let filterDataPoints = [];
  let studentEmotionData = {};
  let studentSupportData = {};
  let bigFiveFilteredData = [];
  const lineGraphSourceData = [];
  const contextFilteredDataPoints = [];
  let tooltipCounts = initializeEmotionDict();

  const now = moment();
  const currentDate = moment().subtract(state.filterAmountCurrent);
  const compareDate = moment().subtract(
    state.filterAmountCurrent + state.filterAmountCompare
  );

  const allEmotions = state.multiEmotion?.emotions || [];

  const processDataPoint = createDataPointProcessor(
    currentDate,
    compareDate,
    now,
    state.chosenEmotion,
    currentDict,
    compareDict,
    currentActionDict,
    compareActionDict,
    impactfulActions,
    filterDataPoints,
    studentEmotionData,
    studentSupportData,
    bigFiveFilteredData,
    state.selectedTimes,
    state.selectedSubOptions,
    state.helpfulFilter,
    tooltipCounts,
    currentParticipants,
    compareParticipants,
    allEmotions,
    lineGraphSourceData
  );

  if (school === "All Schools") {
    processAllSchoolsInDistrict(state, processDataPoint);
  } else if (state.districts[state.chosenDistrict][school]) {
    processSpecificSchool(state, school, processDataPoint);
  }

  newState.filteredDataPoints = filterDataPoints;
  newState.chosenSchool = school;
  newState.chosenClass = "All Classes";
  newState.chosenStudent = "All Students";
  newState.tooltipCounts = tooltipCounts;

  newState.bigFiveFilteredData = bigFiveFilteredData.sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );
  applyLineGraphState(newState, lineGraphSourceData, state.chosenTime, now);
  newState.contextFilteredDataPoints = contextFilteredDataPoints;

  updateEmotions(
    state.feeling,
    state.filterAmountCurrent,
    state.chosenDistrict,
    state,
    emotionDict,
    newState
  );

  transform(currentDict, compareDict, newState);
  transformActions(impactfulActions, newState);
  transformAllActions(currentActionDict, compareActionDict, newState);
  transformFilteredData(studentEmotionData, state.chosenPercentage, newState);
  transformStudentSupportData(
    studentSupportData,
    state.chosenPercentage,
    newState
  );

  computeParticipationPercentChange(
    currentParticipants,
    compareParticipants,
    newState
  );
  return newState;
}
